import CONFIG from "./config";
import log2 from "../js/log2-lite";

const log = log2("utils");
const isHighTrafficHostname = () => {
    const staticSites = ["www.vatanbilgisayar.com"];
    if (staticSites.includes(window.location.hostname)) {
        return true;
    } else if (window.location.hostname.includes("betnano")) {
        return true;
    }
    return false;
};

// CDN URL'i belirle
const getCdnUrl = () => {
    log.debug("getCdnUrl in static config", CONFIG);
    return CONFIG.IS_PROD_ENV ? "https://apicdn.supsis.live/api/" : CONFIG.TABLET_URL;
};

// CDN'den servis edilecek path'ler
const CDN_PATHS = ["public/settings/get-all", "sites/search/", "public/loginForms/get-all", "public/subjects/get-all"];

// Path'in CDN'den servis edilip edilmeyeceğini kontrol eder
const shouldUseCdn = (url) => {
    return CDN_PATHS.some((path) => url.startsWith(path) || url.includes(path));
};

// URL'i CDN path kontrolüne göre oluşturur
const buildUrl = (path) => {
    const baseUrl = !CONFIG.IS_STAGE_ENV && shouldUseCdn(path) ? getCdnUrl() : CONFIG.TABLET_URL;
    return baseUrl + path;
};

const tryRequest = async (requestFn, maxAttempts = 10, retryDelay = 5000) => {
    const attempt = async (attempts = 1) => {
        try {
            if (attempts > 1) {
                log(`Deneme ${attempts}/${maxAttempts} - ${retryDelay / 1000} saniye bekleniyor...`);
                await new Promise((resolve) => setTimeout(resolve, retryDelay));
            }
            const response = await requestFn();
            if (response.status === 200) {
                return await response.json();
            }
            if (attempts < maxAttempts) {
                return attempt(attempts + 1);
            } else {
                return undefined;
            }
        } catch (ex) {
            if (attempts < maxAttempts) {
                return attempt(attempts + 1);
            } else {
                log(`${maxAttempts} deneme sonrası başarısız oldu`);
                return undefined;
            }
        }
    };

    return attempt();
};

export const fetchSiteData = () => {
    log("fetching site data");
    const cachedData = localStorage.getItem("supsis-site-data");
    if (cachedData) {
        const { data, timestamp } = JSON.parse(cachedData);
        if (Date.now() - timestamp < 24 * 60 * 60 * 1000) {
            // 1 gün
            log("using cached site data");
            return Promise.resolve(data);
        }
    }

    const makeRequest = () => fetch(buildUrl(`sites/search/customer/${CONFIG.DOMAIN}`));

    return tryRequest(makeRequest).then((json) => {
        if (json) {
            log("site data", json);
            localStorage.setItem(
                "supsis-site-data",
                JSON.stringify({
                    data: json,
                    timestamp: Date.now(),
                })
            );
        }
        return json;
    });
};

export const fetchSiteSetting = (siteId) => {
    log("fetching site settings");
    if (isHighTrafficHostname()) {
        const cachedSettings = localStorage.getItem("supsis-settings");
        if (cachedSettings) {
            const { data, timestamp } = JSON.parse(cachedSettings);
            if (Date.now() - timestamp < 60 * 1000) {
                // 1 saat
                log("using cached site settings");
                return Promise.resolve(data);
            }
        }
    }

    const makeRequest = () =>
        fetch(buildUrl(`public/settings/get-all?contain=visibilityConfig,liveTraffic,liveAnalytics&lite=true`), {
            headers: {
                "site-id": siteId,
            },
        });

    return tryRequest(makeRequest).then((settings) => {
        if (settings) {
            log("site settings fetched", settings);
            if (isHighTrafficHostname()) {
                localStorage.setItem(
                    "supsis-settings",
                    JSON.stringify({
                        data: settings,
                        timestamp: Date.now(),
                    })
                );
            }
        }
        return settings;
    });
};

export const checkViewPort = function () {
    log("checkViewPort");
    let maybeMeta = document.querySelector("meta[name='viewport']");
    if (maybeMeta) {
        let content = maybeMeta.getAttribute("content");
        if (!content.includes("user-scalable=no")) {
            maybeMeta.setAttribute("content", content + ", user-scalable=no");
        } else {
            let meta = document.createElement("meta");
            meta.content = "width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimal-ui";
            meta.name = "viewport";
            document.head.appendChild(meta);
        }
    }
};

export const onDocReady = () => {
    return new Promise((resolve, reject) => {
        if (document.readyState === "complete" || document.readyState === "interactive") {
            setTimeout(resolve, 1);
        } else {
            document.addEventListener("DOMContentLoaded", resolve);
        }
    });
};



//////////////////
// WEBPACK FOOTER
// ./static/src/utils.js
// module id = null
// module chunks = 